import {Component} from '@angular/core';
import {SourceElementUtils} from '@application/helper/source-element-utils';
import {PositionOfDialog} from '@domain/position-of-dialog';
import {BmpProductionScheduleItemInPathGroup} from '@domain/production-schedule/bmp-production-schedule-item-in-path-group';
import {RepositionDialogComponent} from '@presentation/components/reposition-dialog/reposition-dialog.component';
import {FinishingDetailsComponent} from '@presentation/pages/texfab/production-schedule/finishing-details/finishing-details.component';
import {AssertionUtils, DialogBuilderFactoryService} from '@vdw/angular-component-library';
import {ICellRendererAngularComp} from 'ag-grid-angular';

@Component({
  templateUrl: './finishing-list-view-information.component.html',
  styleUrls: ['./finishing-list-view-information.component.scss']
})
export class FinishingListViewInformationComponent implements ICellRendererAngularComp {
  public productionScheduleItem: BmpProductionScheduleItemInPathGroup;

  public constructor(private readonly dialogBuilderFactoryService: DialogBuilderFactoryService) {}

  public agInit(params: any): void {
    this.productionScheduleItem = params?.data as BmpProductionScheduleItemInPathGroup;
  }

  public refresh(params: any): boolean {
    return false;
  }

  public canShowData(): boolean {
    return !AssertionUtils.isNullOrUndefined(this.productionScheduleItem.finishing);
  }

  public showFinishingDetails(event: MouseEvent, productionScheduleItem: BmpProductionScheduleItemInPathGroup): void {
    this.dialogBuilderFactoryService
      .getBuilder()
      .withClass('reposition-dialog')
      .withWidth('312px')
      .withMaxHeight('100%')
      .openDialog(RepositionDialogComponent, {
        finishing: productionScheduleItem.finishing,
        component: FinishingDetailsComponent,
        sourceElement: SourceElementUtils.findSourceElementForDialog(event, 'info-balloon-container'),
        positionOfDialog: PositionOfDialog.RIGHT
      });
  }
}
